export type HeroSlideTheme = "lite" | "grey" | "dark";

export function resolveHeroSlideTheme(theme: string | null | undefined): HeroSlideTheme {
  if (theme === "grey" || theme === "dark") {
    return theme;
  }
  return "lite";
}

export function getHeroSlideThemeClasses(theme: HeroSlideTheme): {
  section: string;
  heading: string;
  body: string;
  tagVariant: "default" | "onTinted";
  paginationDotActive: string;
  paginationDotInactive: string;
} {
  if (theme === "dark") {
    return {
      section: "bg-secondary text-secondary-foreground",
      heading: "text-secondary-foreground",
      body: "text-secondary-foreground",
      tagVariant: "onTinted",
      paginationDotActive: "bg-secondary-foreground",
      paginationDotInactive: "border-secondary-foreground/40 bg-transparent",
    };
  }

  if (theme === "grey") {
    return {
      section: "bg-muted text-foreground",
      heading: "text-foreground",
      body: "text-foreground",
      tagVariant: "default",
      paginationDotActive: "bg-foreground",
      paginationDotInactive: "border-foreground/40 bg-transparent",
    };
  }

  return {
    section: "bg-background text-foreground",
    heading: "text-foreground",
    body: "text-foreground",
    tagVariant: "default",
    paginationDotActive: "bg-foreground",
    paginationDotInactive: "border-foreground/40 bg-transparent",
  };
}
